import { useEffect, useRef } from 'react';

import { FieldWrapperPassThroughProps } from './FieldWrapper';

declare let google: any;

type LocationInputFieldProps = FieldWrapperPassThroughProps & {
  className?: string;
  id?: string;
  value?: string;
  onChange?: (place: any) => void;
  onTextChange?: (place: any) => void;
  placeholder?: string;
};

export const LocationInputField = (props: LocationInputFieldProps) => {
  const { className, id, value, onChange, placeholder, onTextChange } = props;
  const inputRef = useRef(null);
  let autoComplete: any = null;

  const getDetails = () => {
    if (!autoComplete) return;

    const place = autoComplete.getPlace();

    if (!place) return;

    const el: any = inputRef.current;
    el.value = place.name;

    if (typeof onChange !== 'function') return;

    const op: { [key: string]: any } = {
      name: place.name,
      icon: place.icon,
      address: place.formatted_address,
      url: place.url,
      phone: place.formatted_phone_number,
      website: place.website,
      opening_hours: place.opening_hours,
      place_id: place.place_id,
      country: '',
    };
    if (place.address_components) {
      const countryComponent = place.address_components.find((component: any) =>
        component.types.includes('country')
      );
      if (countryComponent) {
        op.country = countryComponent.long_name;
      }
    } else {
      console.log("No address_components found");
    }
    onChange({ target: { id, value: op } });
  };

  useEffect(() => {
    const options = {
      fields: [
        'place_id',
        'icon',
        'name',
        'formatted_address',
        'formatted_phone_number',
        'website',
        'opening_hours',
        'address_components'
      ],
      strictBounds: false,
    };

    if (inputRef && inputRef.current && google && google.maps && google.maps.places) {
      autoComplete = new google.maps.places.Autocomplete(inputRef.current, options);
      google.maps.event.addListener(autoComplete, 'place_changed', getDetails);
    }
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      className={className}
      id={id}
      onChange={onTextChange}
      defaultValue={value}
      placeholder={placeholder}
    />
  );
};
